// i18n
import translations from 'presentations/views/components/pages/products/DownloadPage/i18n.json';
import { translateInComponent } from 'infras/i18n';

import { useContext } from 'react';
import { GetStaticPropsContext } from 'next';

import MainDocument from 'presentations/views/components/MainDocument';
import DownloadPage from 'presentations/views/components/pages/products/DownloadPage';
import { ServicePortalContext } from 'presentations/reducers/ServicePortal';
import { downloadsPath, webPath } from 'presentations/routes/path';

interface ServerProps {
  linkCanonical: string;
}

export async function getStaticProps({ locale }: GetStaticPropsContext) {
  return {
    props: {
      linkCanonical: webPath(downloadsPath(), locale),
    },
  };
}

export default function Page(props: ServerProps) {
  const t = translateInComponent(translations);
  const { state: serviceState } = useContext(ServicePortalContext);
  const viewer = serviceState.viewer;

  return (
    <MainDocument
      title={t('title')}
      description={t('description')}
      linkCanonical={props.linkCanonical}
    >
      <DownloadPage viewer={viewer} />
    </MainDocument>
  );
}
